import i18n from "../i18n";
import { formatViewerDateTime } from "./viewerTimeZone";

// Time range of the EVENT tables (alarms, anomalies) on a dashboard. Events are sparse, so a range that suits the trend charts
// (minutes/hours, one shared picker) often shows an empty table although events exist. Each event table therefore has its own range:
// "global" follows the shared picker, or a fixed 24h / 7d / 30d; the default is 7d. An empty table says so and offers the
// next wider range with the last event it found. Labels are getters so they follow the selected language.
const rangeChoice = (value) => ({ value, get label() { return i18n.t(`home.events.range.${value}`); } });
export const EVENT_RANGE_CHOICES = ["global", "24h", "7d", "30d"].map(rangeChoice);
export const DEFAULT_EVENT_RANGE = "7d";
const STORAGE_KEY = "valonix_event_ranges";
const ORDER = ["5m", "15m", "30m", "1h", "6h", "24h", "7d", "30d"];
const WIDER = ["24h", "7d", "30d"];

export const eventRangeChoice = (widgetId, stored, config) => (stored && stored[widgetId]) || (config && config.timeRange) || DEFAULT_EVENT_RANGE;

export const resolveEventRange = (choice, globalRange) => (choice === "global" ? globalRange : choice);

/** The next preset wider than `range` that is worth offering, or null when 30d is already the widest. */
export function widerEventRange(range) {
  const at = ORDER.indexOf(range);
  return WIDER.find((r) => ORDER.indexOf(r) > at) || null;
}

export function loadEventRanges(storage) {
  try {
    return JSON.parse(storage.getItem(STORAGE_KEY) || "{}") || {};
  } catch (e) {
    return {};
  }
}

export function saveEventRange(storage, widgetId, choice) {
  try {
    storage.setItem(STORAGE_KEY, JSON.stringify({ ...loadEventRanges(storage), [widgetId]: choice }));
  } catch (e) {
    /* a per-viewer convenience: without storage the choice just lasts until the page is reloaded */
  }
}

/**
 * Text under an empty event table. `kind` = "alarm" | "anomaly" | "event"; `lastAt` = the newest event found in the widest lookup
 * (ISO time) or null.
 */
export function emptyEventHint(kind, range, lastAt, locale) {
  const noun = (form) => i18n.t(`home.events.kinds.${kind}.${form}`, { defaultValue: kind });
  const head = i18n.t(ORDER.includes(range) ? `home.events.empty.${range}` : "home.events.empty.unknown", { kind: noun("plural") });
  if (!lastAt) return `${head} ${i18n.t("home.events.noneIn30")}`;
  return `${head} ${i18n.t("home.events.last", { kind: noun("singular"), when: formatViewerDateTime(lastAt, locale) })}`;
}
